import { StickerCard } from "@/components/sticker-card/StickerCard.tsx";
import { useImportDataEditContext } from "@/pages/settings/import-data/edit/import-data-edit.types.ts";
import { Button, FullScreenPage, Stack, Text, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export function ImportDataEditStepFinal() {
  const { t } = useTranslation();
  const { file, rowsCount } = useImportDataEditContext();
  const navigate = useNavigate();

  return (
    <FullScreenPage contentSize={"lg"}>
      <Stack direction={"horizontal"} items={"center"}>
        <StickerCard
          emoji={":puzzle_piece:"}
          title={t("import_data:import_data_title")}
          contentSlot={
            <Stack className={"text-secondary"}>
              <Text>{file?.name}</Text>
              <Text>{t("plurals:records", { count: rowsCount })}</Text>
            </Stack>
          }
        />
        <Stack className={"pl-18"} gap={"xl"}>
          <Title
            size={"lg"}
            header={t("import_data:import_in_progress")}
            caption={t("import_data:import_in_progress_description")}
          />
          <Stack direction={"horizontal"}>
            <Button
              size={"lg"}
              onClick={() => {
                navigate("/settings/import-data");
              }}
            >
              {t("import_data:view_results")}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </FullScreenPage>
  );
}
